/* eslint-disable semi */
/* eslint-disable max-classes-per-file */
export class HttpError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export class FetchBase {
  protected baseUrl: string
  protected serviceUrl: string

  constructor(baseUrl: string, serviceUrl: string) {
    this.baseUrl = baseUrl.replace(/\/$/, '')
    this.serviceUrl = serviceUrl.replace(/\/$/, '')
  }

  protected getUrl(action: string): string {
    return `${this.baseUrl}${this.serviceUrl}/${action}`
  }

  protected async ajaxRequest(method: string, action: string, data?: any): Promise<any> {
    const response = await fetch(this.getUrl(action), {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    let errorMessage = 'An error occurred';
    if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            const errorData = await response.json();
            errorMessage = errorData.message || JSON.stringify(errorData);
        } else {
            errorMessage = await response.text();
        }
        throw new HttpError(errorMessage, response.status);
    }

    return response.json()
  }
}
